import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { CartProvider } from "./context/CartContext";
import { LanguageProvider } from "./context/LanguageContext";
import { Toaster } from "./components/ui/sonner";
import DisclaimerModal from "./components/DisclaimerModal";
import ShipsTodayBanner from "./components/ShipsTodayBanner";
import FlashSaleBanner from "./components/FlashSaleBanner";
import { FLASH_SALE } from "./data/promotions";
import AiChatWidget from "./components/AiChatWidget";
import ScrollToTop from "./components/ScrollToTop";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import About from "./pages/About";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import Checkout from "./pages/Checkout";
import BulkPricing from "./pages/BulkPricing";

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <CartProvider>
          <BrowserRouter>
            <ScrollToTop />
            <div className="App">
              <DisclaimerModal />
              <AiChatWidget />
              <Header />
              <div className="relative z-40 mt-20 -mb-20">
                {FLASH_SALE.active && <FlashSaleBanner />}
                <ShipsTodayBanner />
              </div>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/products" element={<Products />} />
                <Route path="/product/:id" element={<ProductDetail />} />
                <Route path="/about" element={<About />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/bulk" element={<BulkPricing />} />
              </Routes>
              <Footer />
              <CartDrawer />
              <Toaster />
            </div>
          </BrowserRouter>
        </CartProvider>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
